<template>
  <div id="no-organisation-wrapper">
    <SelectMember class="floating-top-left"/>

    <div
      id="info"
      class="flex column center-all">
      <span class="emoji-fix">😐</span>
      <h3>You don't have access to any organisation.</h3>
      <b-button
        class="flex center-all"
        @click="addOrganisation">
        <SBIcon
          :icon="SBIconList.PLUS"
          :color="SBColors.blackPrimary"
          :size="8" />
        Create new organisation
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SelectMember from '@/components/member/SelectMember';
import JuneMixin from '@/mixins/June';

export default {
  name: 'NoOrganisation',
  components: {
    SelectMember,
    SBIcon,
  },
  mixins: [
    JuneMixin,
  ],
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      organisationList: 'organisation/organisationList',
      me: 'organisation/me',
      currentOrganisation: 'organisation/currentOrganisation',
    }),
  },
  beforeMount() {
    this.fetchOrganisations()
      .then(() => {
        if (this.organisationList.length) {
          this.$router.push({ name: 'Organisation' }).catch(() => {});
        } else {
          this.finalizeSplashView();
        }
      });
  },
  methods: {
    ...mapActions({
      finalizeSplashView: 'organisation/finalizeSplashView',
      fetchOrganisations: 'organisation/fetchOrganisations',
    }),
    addOrganisation() {
      this.juneTrack('Create New Organisation Button');
      window.open('https://tally.so/r/3jBYxx', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  #no-organisation-wrapper {
    display: flex;
    align-items: stretch;
    flex-grow: 1;

    .floating-top-left {
      position: absolute;
    }

    #organisation-panel {
      width: 258px;
      background-color: #f7fafc;
      border-right: 1px solid #e6ebed;
    }

    #info {
      background-color: $white;
      flex-grow: 1;

      span {
        font-size: 58px;
      }

      h3 {
        max-width: 270px;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        color: $blackLight;
        margin-top: 18px;
      }

      .btn {
        margin-top: 40px;

        .sb-icon {
          margin-right: 6px;
        }
      }
    }
  }
</style>
